// extracted by mini-css-extract-plugin
export default {"redStar":"Star_redStar__UIG6S"};